// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-progress-bar {
  position: absolute;
}

.close-btn {
  position: absolute;
  right: 10px;
  margin-right: 8px;
}

.withOverlay {
  top: 35px;
}

.withoutOverlay {
  top: calc(var(--ion-safe-area-top) + 10px);
}

ion-content .info {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
ion-content .info ion-icon {
  font-size: 5em;
}
ion-content .info .download-btn {
  width: 65%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/update-app-modal/update-app-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,0CAAA;AACF;;AAGE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAJ;AAEI;EACE,cAAA;AAAN;AAGI;EACE,UAAA;AADN","sourcesContent":["ion-progress-bar {\n  position: absolute;\n}\n\n.close-btn {\n  position: absolute;\n  right: 10px;\n  margin-right: 8px;\n}\n\n.withOverlay {\n  top: 35px;\n}\n\n.withoutOverlay {\n  top: calc(var(--ion-safe-area-top) + 10px);\n}\n\nion-content {\n  .info {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    ion-icon {\n      font-size: 5em;\n    }\n\n    .download-btn {\n      width: 65%;\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
